/* Mega menu: toggle, click-outside, Escape, focus return. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-os-header]:not([data-os-header-ready])').forEach((wrap) => {
      wrap.dataset.osHeaderReady = 'true';
      // Compact mode once the sticky bar has left its resting spot.
      const section = wrap.closest('.shopify-section') || wrap;
      let restTop = 0;
      // offsetTop is the layout position, so a resize while the bar is stuck still measures its rest spot.
      const measure = () => { restTop = section.offsetTop; };
      const onScroll = () => wrap.classList.toggle('is-stuck', window.scrollY > restTop + 4);
      measure(); onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => { measure(); onScroll(); });

      const trigger = wrap.querySelector('[data-os-menu-trigger]');
      const panel = wrap.querySelector('[data-os-menu]');
      if (!trigger || !panel) return;

      const setOpen = (open) => {
        panel.hidden = !open;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(panel.hidden);
      });
      // The document-level listeners live exactly as long as this header: the
      // theme editor unloads and re-renders the section, and each render must
      // not leave another pair behind.
      const life = new AbortController();
      const { signal } = life;
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !panel.hidden) { setOpen(false); trigger.focus(); }
      }, { signal });
      document.addEventListener('click', (e) => {
        if (!panel.hidden && !wrap.contains(e.target)) setOpen(false);
      }, { signal });
      document.addEventListener('shopify:section:unload', (e) => {
        if (e.target.contains(wrap) || !document.contains(wrap)) life.abort();
      }, { signal });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
